<template>
    <div class="consent-manager">
        <dt class="consent-manager__label">
            {{ label }}
        </dt>
        <dd class="consent-manager__value">
            <span class="consent-manager__value__display">{{ display }}</span>
            <a v-if="granted"
               class="consent-manager__link"
               href="#"
               @click="$emit('withdraw')">withdraw</a>
            <a v-else
               class="consent-manager__link"
               href="#"
               @click="$emit('grant')">allow</a>
        </dd>
    </div>
</template>

<script>

export default {

    props: {
        display: {
            type: String,
            required: true,
        },
        granted: {
            type: Boolean,
            required: true,
        },
        label: {
            type: String,
            default: 'Consent',
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\my-account\_consent-manager.scss

.consent-manager {

    @include element('label') {
        font-weight: bold;

        @include bp-min-small {
            display: inline;

            &:after {
                content: ':'
            }
        }
    }

    @include element('value') {
        margin-inline-start: 0;

        @include bp-min-small {
            display: inline;
            margin-inline-start: 10px;
        }
    }

    @include element('link') {
        margin-left: 10px;
    }
}

</style>
